/* Draft growth experience: explicit choices, shipping clarity, safe interaction events. */
(() => {
  // ANALYTICS HOOKS (loop #39). The kill switch is the first statement of the inline block above
  // {{ content_for_header }} in layout/theme.liquid: window.JSOC_ANALYTICS_HOOKS_OFF = true disables every
  // hook #39 added -- the fabric map (written by that inline block), the automation flag, story_read,
  // scroll_depth, page_engagement, batched list impressions and the GA identifiers on the cart -- and
  // restores the previous one-event-per-card impressions.
  const hooksOn = window.JSOC_ANALYTICS_HOOKS_OFF !== true;
  // Release marker: an execution witness a probe can read (Shopify minifies assets, so served bytes cannot be hashed).
  try { document.documentElement.dataset.jGrowthRelease = 'r2-o2-join-key-2026-09-20'; } catch (_) {}
  // The automation flag must exist before ANY jsoc: event on this page, including replayed navigation
  // events below: the GA4 pixel reads it to stamp traffic_type=internal.
  if (hooksOn) {
    try { if (navigator.webdriver === true) sessionStorage.setItem('jsoc_automation', '1'); } catch (_) {}
  }
  const path = location.pathname;
  const lastSegment = () => path.split('/').filter(Boolean).pop() || '';
  const pageType = path.includes('/products/') ? 'product'
    // A story needs a handle: the /blogs/field-notes index (with or without a trailing slash) is 'other' (AC-5).
    : /^\/blogs\/field-notes\/[^/]+/.test(path) ? 'story'
    : path === '/' ? 'home'
    : path.startsWith('/collections') ? 'collection'
    : path === '/search' ? 'search'
    : path === '/cart' ? 'cart'
    : path.startsWith('/pages/') ? 'page' : 'other';

  // Native Google & YouTube owns GA initialization and ecommerce. Only validated
  // theme-specific events use its existing queue, after affirmative privacy consent.
  const PRODUCT_HANDLES = ["jsoc-logo-zip-hoodie", "jwhs-class-of-2000-custom", "mog-mile-army-pt", "moonless-nights-army-pt", "for-having-the-guts-to-try-triblend-tee", "operation-anaconda-triblend-tee", "world-tour-triblend-tee", "sierra-hotel-triblend-tee", "the-only-easy-day-triblend", "devgru-swim-triblend", "moonless-night-triblend", "first-in-triblend", "mog-mile-triblend-tee", "jsoc-logo-tee-100-cotton-white-logo-1", "jsoc-logo-tee-triblend-black-logo-1", "jsoc-logo-premium-pullover-hoodie"];
  const VARIANT_ITEMS = {"52779124490469":"4739303_24251","52779124523237":"4739303_24257","52779124556005":"4739303_24263","52779124588773":"4739303_24269","52779124621541":"4739303_24275","52779124654309":"4739303_25689","52779124687077":"4739303_24254","52779124719845":"4739303_24260","52779124752613":"4739303_24266","52779124785381":"4739303_24272","52779124818149":"4739303_24278","52779124850917":"4739303_25692","52779124883685":"4739303_24252","52779124916453":"4739303_24258","52779124949221":"4739303_24264","52779124981989":"4739303_24270","52779125014757":"4739303_24276","52779125047525":"4739303_25690","52779125080293":"4739303_24253","52779125113061":"4739303_24259","52779125145829":"4739303_24265","52779125178597":"4739303_24271","52779125211365":"4739303_24277","52779125244133":"4739303_25691","44450014200037":"8084761_6520","44450014232805":"8084761_6521","44450014265573":"8084761_6522","44450014298341":"8084761_6523","44450014331109":"8084761_6524","44450014363877":"8084761_6525","44450014396645":"8084761_6526","44165752553701":"7293605_8440","44165752586469":"7293605_8441","44165752619237":"7293605_8442","44165752652005":"7293605_8443","44165752684773":"7293605_8444","44165752717541":"7293605_8445","44165752750309":"7293605_8446","44165751701733":"4074139_8440","44165751734501":"4074139_8441","44165751767269":"4074139_8442","44165751800037":"4074139_8443","44165751832805":"4074139_8444","44165751865573":"4074139_8445","44165751898341":"4074139_8446","44165707497701":"1969487_16728","44165707530469":"1969487_16729","44165707563237":"1969487_16730","44165707596005":"1969487_16731","44165707628773":"1969487_16732","44165707661541":"1969487_16733","44165707694309":"1969487_16734","44130948579557":"7154314_6576","44130948612325":"7154314_6577","44130948645093":"7154314_6578","44130948677861":"7154314_6579","44130948710629":"7154314_6580","44130948743397":"7154314_6581","44130948776165":"7154314_6582","44130948251877":"5376200_6504","44130948284645":"5376200_6505","44130948317413":"5376200_6506","44130948350181":"5376200_6507","44130948382949":"5376200_6508","44130948415717":"5376200_6509","44130948448485":"5376200_6510","44130948481253":"5376200_6511","44130943402213":"9138932_6600","44130943434981":"9138932_6601","44130943467749":"9138932_6602","44130943500517":"9138932_6603","44130943533285":"9138932_6604","44130943566053":"9138932_6605","44130943598821":"9138932_6606","44089490702565":"1763526_6821","44089490735333":"1763526_6822","44089490768101":"1763526_6823","44089490800869":"1763526_6824","44089490833637":"1763526_6825","44089490866405":"1763526_6826","44089489326309":"2984258_6488","44089489359077":"2984258_6489","44089489391845":"2984258_6490","44089489424613":"2984258_6491","44089489457381":"2984258_6492","44089489490149":"2984258_6493","44089488408805":"4599991_6472","44089488441573":"4599991_6473","44089488474341":"4599991_6474","44089488507109":"4599991_6475","44089488539877":"4599991_6476","44089488572645":"4599991_6477","44089487720677":"2075933_6512","44089487753445":"2075933_6513","44089487786213":"2075933_6514","44089487818981":"2075933_6515","44089487851749":"2075933_6516","44089487884517":"2075933_6517","44132199432421":"8469555","44132199465189":"8368079","44131162226917":"5528838","44131209969893":"5235454","44131210002661":"7956145","44131210035429":"4532078","44131210068197":"4421757","44131210100965":"1558903","44131210133733":"6616500","44131210166501":"8328857","44131210199269":"4738202","44131210232037":"5945499","44131210264805":"3754334","44131210297573":"6617503","44131210330341":"5726144","44131210363109":"7786528","44131210395877":"1918527","44131210428645":"4150055","44132199497957":"3479274","44132199530725":"2292175","44132199563493":"7278367","44132199596261":"7643203","44131162292453":"1861093","44131210461413":"9925275","44131210494181":"3462907","44131210526949":"1888110","44131210559717":"5501767","44131210592485":"7326622","44131210625253":"6062102","44131210658021":"3678888","44131210690789":"6522516","44131210723557":"3241950","44131210756325":"8414528","44131210789093":"9031062","44131210821861":"4298449","44131210854629":"7602502","44131210887397":"5953600","44131210920165":"5661654","44132199629029":"3127988","44132199661797":"5445755","44132199694565":"1198804","44132199727333":"6627008","44131162357989":"3525421","44131210952933":"1347622","44131210985701":"3385253","44131211018469":"2854227","44131211051237":"1216003","44131211084005":"9022351","44131211116773":"9808042","44131211149541":"6234817","44131211182309":"9228841","44131211215077":"8404229","44131211247845":"5853893","44131211280613":"7490949","44131211313381":"3520717","44131211346149":"5297759","44131211378917":"2306704","44131211411685":"6612612","44132199760101":"4529888","44132199792869":"1542365","44132199825637":"1417765","44132199858405":"5270271","44131162423525":"7549593","44131211444453":"3141343","44131211477221":"5621699","44131211509989":"2716546","44131211542757":"9069583","44131211575525":"7293218","44131211608293":"4185728","44131211641061":"8328970","44131211673829":"8278504","44131211706597":"8322752","44131211739365":"9027449","44131211772133":"5120108","44131211804901":"4290230","44131211837669":"2362205","44131211870437":"5276403","44131211903205":"1783411","44132199891173":"5394316","44132199923941":"9913191","44132199956709":"8762324","44132199989477":"7011943","44131212984549":"9059150","44131213017317":"9362571","44131213050085":"2228064","44131213082853":"1770564","44131213115621":"3862264","44131213148389":"8217198","44131213181157":"8788996","44131213213925":"6189983","44131213246693":"5184792","44131213279461":"9349672","44131213312229":"3027198","44131213344997":"1085419","44131213377765":"7634337","44131213410533":"3911204","44131213443301":"4813183","44131213476069":"6982639","44132200022245":"3632053","44132200055013":"3245933","44089479561445":"4641630_6504","44089479594213":"4641630_6505","44089479626981":"4641630_6506","44089479659749":"4641630_6507","44089479692517":"4641630_6508","44089479725285":"4641630_6509","43875118547173":"5882773_5594","43875118579941":"5882773_5595","43875118612709":"5882773_5596","43875118645477":"5882773_5597","43875118678245":"5882773_5598","43875118711013":"5882773_10806","43875118743781":"5882773_10807","43875118776549":"5882773_10808","43875118809317":"5882773_10809","43875118842085":"5882773_10810","43875118874853":"5882773_12989","43875118907621":"5882773_12990","43875118940389":"5882773_12991","43875118973157":"5882773_12992","43875119005925":"5882773_12993","43875115073765":"2913774_9527","43875115106533":"2913774_4016","43875115139301":"2913774_4017","43875115172069":"2913774_4018","43875115204837":"2913774_4019","43875115237605":"2913774_4020","43875115270373":"2913774_9546","43875115303141":"2913774_4111","43875115335909":"2913774_4112","43875115368677":"2913774_4113","43875115401445":"2913774_4114","43875115434213":"2913774_4115","43875115663589":"2913774_4171","43875115696357":"2913774_4172","43875115729125":"2913774_4173","43875115761893":"2913774_4174","43875115794661":"2913774_4175","43875115827429":"2913774_4031","43875115860197":"2913774_4032","43875115892965":"2913774_4033","43875115925733":"2913774_4034","43875115958501":"2913774_4035","43875115991269":"2913774_8440","43875116024037":"2913774_8441","43875116056805":"2913774_8442","43875116089573":"2913774_8443","43875116122341":"2913774_8444","43940541169893":"2812890_9552","43940541202661":"2812890_4141","43940541235429":"2812890_4142","43940541268197":"2812890_4143","43940541300965":"2812890_4144","43940541333733":"2812890_4145","44131040428261":"8491332_9543","44131040461029":"8491332_4096","44131040493797":"8491332_4097","44131040526565":"8491332_4098","44131040559333":"8491332_4099","44131040592101":"8491332_4100","44131040624869":"8491332_9554","44131040657637":"8491332_4151","44131040690405":"8491332_4152","44131040723173":"8491332_4153","44131040755941":"8491332_4154","44131040788709":"8491332_4155","44131040821477":"8491332_4146","44131040854245":"8491332_4147","44131040887013":"8491332_4148","44131040919781":"8491332_4149","44131040952549":"8491332_4150","44131040985317":"8491332_9526","44131041018085":"8491332_4011","44131041050853":"8491332_4012","44131041083621":"8491332_4013","44131041116389":"8491332_4014","44131041149157":"8491332_4015","44131047047397":"4588566_4161","44131047768293":"4588566_4162","44131048489189":"4588566_4163","44131049144549":"4588566_4164","44131049439461":"4588566_4165","44131049472229":"4588566_10375","44131049504997":"4588566_10376","44131049537765":"4588566_10377","44131049570533":"4588566_10378","44131049603301":"4588566_10379","44131049636069":"4588566_10380","44131049668837":"4588566_14673","44131049701605":"4588566_14674","44131049734373":"4588566_14675","44131049767141":"4588566_14676","44131049799909":"4588566_14677","44131049832677":"4588566_14678","43875112386789":"2910137_6488","43875112419557":"2910137_6489","43875112452325":"2910137_6490","43875112485093":"2910137_6491","43875112517861":"2910137_6492","43875112550629":"2910137_6493","43940544610533":"9158143_6472","43940544643301":"9158143_6473","43940544676069":"9158143_6474","43940544708837":"9158143_6475","43940544741605":"9158143_6476","43940544774373":"9158143_6477","43940544839909":"9158143_6821","43940544872677":"9158143_6822","43940544938213":"9158143_6823","43940544970981":"9158143_6824","43940545003749":"9158143_6825","43940545036517":"9158143_6826","43940545069285":"9158143_6608","43940545102053":"9158143_6609","43940545134821":"9158143_6610","43940545167589":"9158143_6611","43940545233125":"9158143_6612","43940545265893":"9158143_6613","44131062513893":"3663443_6584","44131062546661":"3663443_6585","44131062579429":"3663443_6586","44131062612197":"3663443_6587","44131062644965":"3663443_6588","44131062677733":"3663443_6589","44131062710501":"3663443_6600","44131062743269":"3663443_6601","44131062776037":"3663443_6602","44131062808805":"3663443_6603","44131062841573":"3663443_6604","44131062874341":"3663443_6605","44131062907109":"3663443_6536","44131062939877":"3663443_6537","44131062972645":"3663443_6538","44131063005413":"3663443_6539","44131063070949":"3663443_6540","44131063103717":"3663443_6541","44131064938725":"2273909_17374","44131064971493":"2273909_17375","44131065004261":"2273909_17376","44131065037029":"2273909_17377","44131065069797":"2273909_17378","44131065102565":"2273909_17379","43875070345445":"5761744_9430","43875070378213":"5761744_9431","43875070410981":"5761744_9432","43875070443749":"5761744_9433","43875070476517":"5761744_9596","43875070509285":"5761744_9599","43875070542053":"5761744_9602","43875070574821":"5761744_9605","43875070607589":"5761744_10632","43875070640357":"5761744_10633","43875070673125":"5761744_10634","43875070705893":"5761744_10635","67577926353125":"7840099","67577926385893":"1632481","67577926418661":"1047355","67577926451429":"5578299","67577926484197":"5631874","67577926516965":"8607841","67577926549733":"4431361","67577926582501":"6174758","67577926615269":"4593301","67577926648037":"1343786","67577926680805":"3050272","67577926713573":"1006420","67577926746341":"8729633","67577926779109":"8295139","67577926811877":"4325923","67577926844645":"2337923","67577926877413":"5312681","67577926910181":"5401428","67577926942949":"7702738","67577926975717":"4407373","67577927008485":"8076577","67577927041253":"2111748","67577927074021":"5411173","67577927106789":"4964976","67577927139557":"3047847","67577927172325":"6090931","67577927205093":"7608961","67577927237861":"8039803","67577927270629":"4243912","67577927303397":"5605131"};
  const STORY_IDS = ['for-having-the-guts-to-try','the-mogadishu-mile','what-sierra-hotel-means','only-easy-day-was-yesterday-origin'];
  const nativeEvents = new Set(['variant_selected', 'size_guide_open', 'story_view',
    'story_read', 'story_product_exposure', 'story_product_click', 'sign_up',
    'scroll_depth', 'contact_success', 'community_contribution_success', 'cart_add_confirmed']);
  const pendingInitial = [];
  const sentInitial = new Set();
  let initialTimer = null;
  let consentLoadStarted = false;
  const nativeReady = () => Array.isArray(window.dataLayer) &&
    !!window.google_tag_manager?.['G-K06YN9QPLC'];
  const initialKey = (name, d) => name + ':' + JSON.stringify(d);
  const onceOnly = (name, replayed) => name === 'story_view' ||
    (name === 'story_product_click' && replayed) ||
    ['cart_add_confirmed', 'contact_success', 'community_contribution_success', 'sign_up'].includes(name);
  const initialData = (name, d, replayed) => {
    if (name === 'story_view' && STORY_IDS.includes(d.story_id))
      return { story_id: d.story_id };
    if (name === 'story_product_click' &&
        STORY_IDS.includes(d.story_id) && PRODUCT_HANDLES.includes(d.product_handle))
      return { story_id: d.story_id, product_handle: d.product_handle };
    if (name === 'cart_add_confirmed' &&
        Object.prototype.hasOwnProperty.call(VARIANT_ITEMS, d.variant_id) &&
        Number.isInteger(d.quantity) && d.quantity > 0 && d.quantity <= 100 &&
        Number.isFinite(d.price) && d.price >= 0 && d.currency === 'USD')
      return { variant_id: String(d.variant_id), quantity: d.quantity,
        price: d.price, currency: 'USD' };
    if (name === 'contact_success' && d.placement === 'contact' &&
        ['order', 'delivery', 'product-issue', 'review', 'fit', 'community',
          'correction', 'other'].includes(d.topic))
      return { placement: 'contact', topic: d.topic };
    if (name === 'sign_up' && d.method === 'field_notes' &&
        ['home', 'article', 'footer'].includes(d.placement))
      return { method: 'field_notes', placement: d.placement };
    if (name === 'variant_selected' && PRODUCT_HANDLES.includes(d.product_handle) &&
        Object.prototype.hasOwnProperty.call(VARIANT_ITEMS, d.variant_id))
      return { product_handle: d.product_handle, variant_id: String(d.variant_id) };
    if (name === 'size_guide_open' && PRODUCT_HANDLES.includes(d.product_handle))
      return { product_handle: d.product_handle };
    if (name === 'story_read' && STORY_IDS.includes(d.story_id))
      return { story_id: d.story_id };
    if (name === 'story_product_exposure' && d.story_id === 'for-having-the-guts-to-try' &&
        d.product_handle === 'for-having-the-guts-to-try-triblend-tee')
      return { story_id: d.story_id, product_handle: d.product_handle };
    if (name === 'scroll_depth' && [50, 90].includes(d.percent) &&
        d.page_type === 'product' && PRODUCT_HANDLES.includes(d.product_handle))
      return { percent: d.percent, page_type: 'product', product_handle: d.product_handle };
    if (name === 'community_contribution_success' && d.placement === 'contact')
      return { placement: 'contact' };
    return null;
  };
  const nativeSend = (name, d, replayed = false) => {
    try {
      if (window.JSOC_NATIVE_GA4 !== true || window.JSOC_ANALYTICS_EXCLUDED === true ||
          !nativeEvents.has(name) || !d || typeof d !== 'object' || Array.isArray(d)) return;
      const privacy = window.Shopify?.customerPrivacy;
      const allowed = typeof privacy?.analyticsProcessingAllowed === 'function'
        ? privacy.analyticsProcessingAllowed() : undefined;
      if (allowed === false) return;
      if (allowed !== true || !nativeReady()) {
        const safe = initialData(name, d, replayed);
        if (!safe || (onceOnly(name, replayed) && sentInitial.has(initialKey(name, safe)))) return;
        const key = initialKey(name, safe);
        if (!pendingInitial.some((entry) => entry.key === key) && pendingInitial.length < 5)
          pendingInitial.push({ name, data: safe, key, replayed, until: Date.now() + 5000 });
        if (allowed === undefined && !consentLoadStarted &&
            typeof window.Shopify?.loadFeatures === 'function') {
          consentLoadStarted = true;
          try {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
              (error) => { if (error) pendingInitial.length = 0; else flushInitial(); });
          } catch (_) { pendingInitial.length = 0; }
        }
        if (!initialTimer && pendingInitial.length) initialTimer = setInterval(flushInitial, 100);
        return;
      }
      const safe = initialData(name, d, replayed);
      const key = safe && initialKey(name, safe);
      if (key && onceOnly(name, replayed) && sentInitial.has(key)) return;
      if (key) {
        const index = pendingInitial.findIndex((entry) => entry.key === key);
        if (index >= 0) pendingInitial.splice(index, 1);
      }
      const out = {};
      const handle = d.product_handle;
      const story = d.story_id;
      if (name === 'sign_up') {
        if (d.method !== 'field_notes' || !['home', 'article', 'footer'].includes(d.placement)) return;
        out.method = 'field_notes'; out.placement = d.placement;
      } else if (name === 'story_product_exposure') {
        if (story !== 'for-having-the-guts-to-try' ||
            handle !== 'for-having-the-guts-to-try-triblend-tee') return;
        out.story_id = story; out.product_handle = handle;
      } else if (name === 'scroll_depth') {
        if (![50, 90].includes(d.percent) || d.page_type !== 'product' ||
            !PRODUCT_HANDLES.includes(handle)) return;
        out.percent = d.percent; out.product_handle = handle;
      } else if (name === 'cart_add_confirmed') {
        if (!Object.prototype.hasOwnProperty.call(VARIANT_ITEMS, d.variant_id) ||
            !Number.isInteger(d.quantity) || d.quantity < 1 || d.quantity > 100 ||
            !Number.isFinite(d.price) || d.price < 0 || d.currency !== 'USD') return;
        out.currency = 'USD'; out.value = d.price * d.quantity;
        out.item_id = VARIANT_ITEMS[d.variant_id]; out.quantity = d.quantity;
        out.items = [{ item_id: out.item_id, price: d.price, quantity: d.quantity }];
      } else if (name === 'contact_success' || name === 'community_contribution_success') {
        if (d.placement !== 'contact') return;
        out.placement = 'contact';
        if (name === 'contact_success') {
          if (!['order', 'delivery', 'product-issue', 'review', 'fit', 'community',
            'correction', 'other'].includes(d.topic)) return;
          out.topic = d.topic;
        }
      } else {
        if (story && STORY_IDS.includes(story)) out.story_id = story;
        if (handle && PRODUCT_HANDLES.includes(handle)) out.product_handle = handle;
        if (d.variant_id && Object.prototype.hasOwnProperty.call(VARIANT_ITEMS, d.variant_id))
          out.variant_id = String(d.variant_id);
        if (!Object.keys(out).length) return;
      }
      (function () { window.dataLayer.push(arguments); })('event', name,
        { ...out, send_to: 'G-K06YN9QPLC' });
      if (key && onceOnly(name, replayed)) sentInitial.add(key);
    } catch (_) { /* Analytics must never interrupt shopping. */ }
  };
  function flushInitial() {
    let allowed;
    try { allowed = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.(); }
    catch (_) { pendingInitial.length = 0; }
    if (window.JSOC_ANALYTICS_EXCLUDED === true || window.JSOC_NATIVE_GA4 !== true) pendingInitial.length = 0;
    if (allowed === false) pendingInitial.length = 0;
    const now = Date.now();
    for (const entry of pendingInitial.slice()) {
      if (now >= entry.until) {
        pendingInitial.splice(pendingInitial.indexOf(entry), 1);
      } else if (allowed === true && nativeReady()) {
        pendingInitial.splice(pendingInitial.indexOf(entry), 1);
        nativeSend(entry.name, entry.data, entry.replayed);
      }
    }
    if (!pendingInitial.length && initialTimer) {
      clearInterval(initialTimer);
      initialTimer = null;
    }
  }
  const publish = (name, data = {}, replayed = false) => {
    nativeSend(name, data, replayed);
    try {
      const result = window.Shopify?.analytics?.publish(`jsoc:${name}`, data);
      result?.catch?.(() => {});
    } catch (_) { /* Analytics must never interrupt shopping. */ }
  };
  const queueNavigation = (name, data) => {
    try {
      const pending = JSON.parse(sessionStorage.getItem('jsoc_navigation_events') || '[]');
      pending.push({ name, data, at: Date.now() });
      sessionStorage.setItem('jsoc_navigation_events', JSON.stringify(pending.slice(-6)));
    } catch (_) { publish(name, data); }
  };
  // Route-changing clicks are dispatched from the destination page so Shopify's
  // sandbox is not destroyed before Google transmits the interaction.
  try {
    const pending = JSON.parse(sessionStorage.getItem('jsoc_navigation_events') || '[]');
    sessionStorage.removeItem('jsoc_navigation_events');
    pending.filter((e) => Date.now() - e.at < 60000).forEach((e) => publish(e.name, e.data, true));
  } catch (_) {}
  if (location.pathname === '/cart') {
    try {
      const addition = JSON.parse(sessionStorage.getItem('jsoc_cart_add_confirmed') || 'null');
      const cart = JSON.parse(document.getElementById('j-cart-analytics')?.textContent || 'null');
      sessionStorage.removeItem('jsoc_cart_add_confirmed');
      const line = cart?.items.find((i) => String(i.variant_id) === addition?.variant_id);
      if (line && Date.now() - addition.at < 60000 && addition.quantity > 0 && line.quantity >= addition.quantity) {
        const confirmed = { variant_id: addition.variant_id, quantity: addition.quantity,
          price: line.final_price / 100, currency: cart.currency };
        if (line.product_id) confirmed.product_id = String(line.product_id);
        if (line.sku) confirmed.sku = String(line.sku);
        publish('cart_add_confirmed', confirmed);
      }
    } catch (_) {}
  }
  const listName = (node) => node.closest('[data-j-list]')?.dataset.jList ||
    (node.closest('.j-core') ? 'home_core' : node.closest('.j-collection') ? 'collection' : 'related');
  // Product-level item for list events. `index` is the card's 1-based position within its own list.
  const listOf = (card) => card.closest('[data-j-list]') || document.body;
  const cardItem = (card) => ({
    item_id: String(card.dataset.jProduct || ''),
    item_name: card.dataset.jName || '',
    price: Number(card.dataset.jPrice),
    index: [...listOf(card).querySelectorAll('[data-j-item]')].indexOf(card) + 1,
    sku: card.dataset.jItem,
  });
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a');
    const card = anchor?.closest('[data-j-item]');
    const track = anchor && anchor.origin === location.origin && !anchor.target && !event.metaKey && !event.ctrlKey && anchor.pathname !== location.pathname ? queueNavigation : publish;
    // Top-level item_id stays the SKU so the GA4 pixel v17 keeps accepting the event.
    if (card) track('select_item', { item_id: card.dataset.jItem, item_list_id: listName(card), items: [cardItem(card)] });
    if (anchor && location.pathname.startsWith('/blogs/field-notes/') && anchor.pathname.startsWith('/products/')) {
      track('story_product_click', { story_id: location.pathname.split('/').pop(), product_handle: anchor.pathname.split('/').pop() });
    }
  });
  document.addEventListener('toggle', (event) => {
    if (event.target.matches?.('details.jsoc-size[open]')) {
      publish('size_guide_open', { product_handle: location.pathname.split('/').pop() });
    }
  }, true);
  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-selects');
    if (!picker) return;
    const selected = [...picker.querySelectorAll('fieldset')].map((f) => f.querySelector(':checked')?.value);
    const store = picker.closest('section')?.querySelector('[data-j-variants]');
    if (!store) return;
    const variants = JSON.parse(store.textContent || '[]');
    const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
    const sizeGroup = picker.querySelector('[data-j-option="size"]');
    const sizeChosen = !sizeGroup || !!sizeGroup.querySelector('input:checked');
    if (variant && sizeChosen) publish('variant_selected', { variant_id: String(variant.id), product_handle: location.pathname.split('/').pop() });
  });

  // Only a successful server response may produce a signup event. The marker is per attempt,
  // and expires so a later page load cannot turn a failed attempt into a conversion.
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-j-newsletter]');
    if (!form) return;
    try { sessionStorage.setItem('jsoc_signup_attempt', JSON.stringify({ placement: form.dataset.jNewsletter, at: Date.now() })); } catch (_) {}
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-j-contact]');
    if (!form) return;
    const selected = form.querySelector('[data-j-contact-topic]')?.value;
    const topic = ['order', 'delivery', 'product-issue', 'review', 'fit', 'community', 'correction', 'other'].includes(selected) ? selected : 'other';
    try { sessionStorage.setItem('jsoc_contact_attempt', JSON.stringify({ topic, at: Date.now() })); } catch (_) {}
  });
  if (document.querySelector('[data-j-contact-success]')) {
    try {
      const attempt = JSON.parse(sessionStorage.getItem('jsoc_contact_attempt') || 'null');
      sessionStorage.removeItem('jsoc_contact_attempt');
      if (attempt && Date.now() - attempt.at >= 0 && Date.now() - attempt.at < 15 * 60 * 1000) {
        // A community submission is reported once, as contact_success with topic "community" (#39 AC-11).
        publish('contact_success', { placement: 'contact', topic: attempt.topic });
      }
    } catch (_) {}
  }
  const success = document.querySelector('[data-j-signup-success]');
  if (success) {
    try {
      const attempt = JSON.parse(sessionStorage.getItem('jsoc_signup_attempt') || 'null');
      if (attempt && Date.now() - attempt.at < 15 * 60 * 1000) {
        publish('sign_up', { method: 'field_notes', placement: attempt.placement });
        sessionStorage.removeItem('jsoc_signup_attempt');
      }
    } catch (_) {}
  }
  if (location.pathname.startsWith('/blogs/field-notes/')) {
    publish('story_view', { story_id: location.pathname.split('/').pop() });
  }

  const seen = new WeakSet();
  if ('IntersectionObserver' in window && !hooksOn) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting || seen.has(target)) return;
        seen.add(target); observer.unobserve(target);
        publish('view_item_list', { item_id: target.dataset.jItem, item_list_id: listName(target) });
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-j-item]').forEach((card) => observer.observe(card));
  } else if ('IntersectionObserver' in window) {
    // Batched impressions: one event per list, 1 s after the first unreported card of the batch becomes
    // >=50% visible, carrying every unreported card visible at flush (max 20). Each card is reported once.
    const BATCH_DELAY_MS = 1000;
    const BATCH_MAX = 20;
    const visible = new Set();
    const timers = new Map();
    const flush = (list) => {
      timers.delete(list);
      const ready = [...list.querySelectorAll('[data-j-item]')]
        .filter((card) => visible.has(card) && !seen.has(card)).slice(0, BATCH_MAX);
      if (!ready.length) return;
      ready.forEach((card) => seen.add(card));
      const items = ready.map(cardItem);
      publish('view_item_list', { item_list_id: listName(ready[0]), items, item_id: items[0].sku });
      const more = [...list.querySelectorAll('[data-j-item]')].some((card) => visible.has(card) && !seen.has(card));
      if (more) timers.set(list, setTimeout(() => flush(list), BATCH_DELAY_MS));
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) { visible.delete(target); return; }
        if (seen.has(target)) return;
        visible.add(target);
        const list = listOf(target);
        if (!timers.has(list)) timers.set(list, setTimeout(() => flush(list), BATCH_DELAY_MS));
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-j-item]').forEach((card) => observer.observe(card));
  }

  if (hooksOn && pageType === 'story') {
    // One visible exposure for the controlled Guts-to-Try CTA, never a scroll-event count.
    const storyCta = document.querySelector('[data-j-story-product-exposure]');
    if (storyCta && 'IntersectionObserver' in window) {
      let exposed = false;
      const observeVisible = () => {
        if (!exposed && document.visibilityState === 'visible') {
          exposureObserver.unobserve(storyCta);
          exposureObserver.observe(storyCta);
        }
      };
      const exposureObserver = new IntersectionObserver((entries) => {
        if (exposed || document.visibilityState !== 'visible') return;
        if (!entries.some((entry) => entry.target === storyCta && entry.isIntersecting && entry.intersectionRatio >= 0.5)) return;
        exposed = true;
        publish('story_product_exposure', {
          story_id: storyCta.dataset.storyId,
          product_handle: storyCta.dataset.productHandle,
        });
        exposureObserver.disconnect();
        document.removeEventListener('visibilitychange', observeVisible);
      }, { threshold: 0.5 });
      document.addEventListener('visibilitychange', observeVisible);
      observeVisible();
    }

    // story_read: once per page load, when the end-of-article sentinel is >=75% visible.
    const sentinel = document.querySelector('[data-j-story-end]');
    if (sentinel && 'IntersectionObserver' in window) {
      const readObserver = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting && e.intersectionRatio >= 0.75)) return;
        readObserver.disconnect();
        publish('story_read', { story_id: lastSegment() });
      }, { threshold: 0.75 });
      readObserver.observe(sentinel);
    }
  }

  if (hooksOn && pageType === 'product') {
    // scroll_depth (product pages only; stories are measured by story_read): 50 and 90, each at most once per
    // page load, measured at the viewport's bottom edge.
    const reached = new Set();
    let depthPending = false;
    const measureDepth = () => {
      depthPending = false;
      const height = document.documentElement.scrollHeight;
      if (!height) return;
      const ratio = (window.scrollY + window.innerHeight) / height;
      [50, 90].forEach((percent) => {
        if (ratio * 100 < percent || reached.has(percent)) return;
        reached.add(percent);
        publish('scroll_depth', { percent, page_type: 'product', product_handle: lastSegment() });
      });
    };
    window.addEventListener('scroll', () => {
      if (!depthPending) { depthPending = true; requestAnimationFrame(measureDepth); }
    }, { passive: true });
    measureDepth();
  }

  if (hooksOn) {
    // page_engagement: whole seconds the page was visible AND focused since the last publish, sent once
    // per hidden transition (visibilitychange->hidden or pagehide, whichever comes first), capped at 1800.
    let engagedMs = 0;
    let activeSince = null;
    let hiddenSent = false;
    const isActive = () => document.visibilityState === 'visible' && document.hasFocus();
    const tick = () => {
      const now = performance.now();
      if (activeSince !== null) engagedMs += now - activeSince;
      activeSince = isActive() ? now : null;
    };
    const sendEngagement = () => {
      tick();
      if (hiddenSent) return;
      hiddenSent = true;
      const seconds = Math.min(1800, Math.floor(engagedMs / 1000));
      engagedMs = 0;
      if (seconds > 0) publish('page_engagement', { engaged_seconds: seconds, page_type: pageType });
    };
    window.addEventListener('focus', tick);
    window.addEventListener('blur', tick);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') sendEngagement();
      else { hiddenSent = false; tick(); }
    });
    setInterval(() => { if (isActive()) { hiddenSent = false; sendEngagement(); hiddenSent = false; } }, 10000);
    window.addEventListener('pagehide', sendEngagement);
    window.addEventListener('pageshow', () => { hiddenSent = false; tick(); });
    tick();
  }

  if (hooksOn) {
    // GA IDENTIFIERS ON THE CART (#39 AC-16). The order must carry the browser's GA client id so a server-side
    // purchase (#41) de-duplicates against the browser's in GA4. Consent, not the cookie, decides: a _ga
    // cookie survives consent withdrawal, so identifiers are written only while Shopify's customer privacy API
    // reports analytics consent (a sale-of-data opt-out does not withhold the join key: the pixel sends under the same rule, D-83), and removed otherwise. The cart state comes from the
    // server-rendered #j-cart-ga block and is refreshed after confirmed cart changes.
    const CONSENT_TIMEOUT_MS = 5000;
    let rendered = null;
    try { rendered = JSON.parse(document.getElementById('j-cart-ga')?.textContent || 'null'); } catch (_) { rendered = null; }
    const state = rendered && typeof rendered.count === 'number'
      ? { count: rendered.count, cid: rendered.cid || null, sid: rendered.sid || null } : null;
    const readCookies = () => {
      const ga = []; let session = null;
      document.cookie.split(';').forEach((part) => {
        const i = part.indexOf('='); if (i < 0) return;
        // Only the two GA cookies are ever decoded, each in its own try: decoding EVERY cookie let one malformed
        // cookie elsewhere (promo=100%) throw out of this block and abort the sticky buy bar below it.
        const name = part.slice(0, i).trim();
        if (name !== '_ga' && name !== '_ga_K06YN9QPLC') return;
        let value = null;
        try { value = decodeURIComponent(part.slice(i + 1).trim()); } catch (_) { value = null; }
        // A _ga is counted by NAME even when it cannot be decoded: a second _ga is identity ambiguity (AC-16).
        if (name === '_ga') ga.push(value);
        else session = value;
      });
      const fields = ga.length === 1 && ga[0] !== null ? ga[0].split('.') : [];
      const cid = fields.length >= 2 ? fields.slice(-2).join('.') : null;
      const sidMatch = session ? /(?:^|\.)s(\d+)/.exec(session) : null;
      return { gaCount: ga.length, cid: cid && /^\d+\.\d+$/.test(cid) ? cid : null, sid: sidMatch ? sidMatch[1] : null };
    };
    let consentApi = null; let consentSettled = false;
    const loadConsent = (then) => {
      const timer = setTimeout(() => { consentSettled = true; then(); }, CONSENT_TIMEOUT_MS);
      const done = (err) => {
        clearTimeout(timer);
        consentApi = !err && window.Shopify?.customerPrivacy ? window.Shopify.customerPrivacy : null;
        consentSettled = true;
        then();   // also runs when the callback arrives after the timeout: a late callback re-evaluates (C10)
      };
      try {
        if (window.Shopify?.customerPrivacy) return done(null);
        if (typeof window.Shopify?.loadFeatures !== 'function') return done(new Error('no loadFeatures'));
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => done(error));
      } catch (e) { done(e); }
    };
    const consentAllowed = () => {
      try { return window.JSOC_ANALYTICS_EXCLUDED !== true && !!consentApi && consentApi.analyticsProcessingAllowed() === true; }
      catch (_) { return false; }
    };
    // Identifier requests are tracked so that what the page REMEMBERS is never mistaken for what the server HOLDS:
    //  * pendingWrites counts identifier writes not yet settled. A withdrawal sends a removal at once whenever the
    //    cart holds identifiers OR a write is pending -- remembered state alone was empty while a write was in flight,
    //    so the removal used to be skipped and the write landed on an opted-out cart.
    //  * dirty means the remembered state cannot be trusted: requests overlapped (response ORDER does not show which
    //    one the server applied last), or a request failed or lost its response (it may have been applied anyway).
    //    While dirty, the desired state is re-sent even when it matches memory -- including a removal after retries
    //    were exhausted -- and dirty clears only on a successful response to a request that overlapped nothing (that
    //    response IS the server's state).
    //  * when the last request settles, the state is re-evaluated.
    //  * automatic re-evaluations are capped per external trigger; exhaustion is marked on <html data-j-ga-sync>.
    // Residual, stated: a keepalive write that lands after the page is gone cannot be cleaned up by this page. The
    // next page load renders the cart's identifiers server-side and removes them if consent is still withheld.
    const MAX_AUTO = 3;
    let outstanding = 0; let pendingWrites = 0; let dirty = false; let autoLeft = MAX_AUTO; let firstSeen = null;
    const remember = (cart) => {
      if (cart && state) {
        state.count = cart.item_count;
        state.cid = cart.attributes?._ga_client_id || null;
        state.sid = cart.attributes?._ga_session_id || null;
      }
    };
    const post = (attributes, alone) => fetch('/cart/update.js', {
      method: 'POST', keepalive: true, credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
    }).then((r) => { if (!r.ok) throw new Error(`update ${r.status}`); return r.json(); })
      .then((cart) => { if (alone && outstanding === 1) { remember(cart); dirty = false; } else { dirty = true; } })
      .catch(() => { dirty = true; });
    const settle = (wasWrite) => {
      outstanding -= 1;
      if (wasWrite) pendingWrites -= 1;
      if (outstanding > 0) return;
      if (autoLeft <= 0) { try { document.documentElement.dataset.jGaSync = 'exhausted'; } catch (_) {} return; }
      autoLeft -= 1;
      runSync();
    };
    const syncGaCartNow = () => {
      if (!state || !consentSettled) return;
      const cookies = readCookies();
      if (firstSeen === null) firstSeen = cookies;
      const allowed = consentAllowed() && cookies.gaCount === 1 && cookies.cid !== null;
      const want = allowed && state.count > 0 ? { cid: cookies.cid, sid: cookies.sid } : { cid: null, sid: null };
      const removing = want.cid === null;
      if (!dirty && pendingWrites === 0 && want.cid === state.cid && want.sid === state.sid) return;
      // nothing to remove: the cart holds no identifiers, no write is pending, and memory is trustworthy
      if (removing && !dirty && pendingWrites === 0 && state.cid === null && state.sid === null) return;
      const attributes = {
        _ga_client_id: want.cid === null ? '' : want.cid,
        _ga_session_id: want.sid === null ? '' : want.sid,
      };
      if (outstanding > 0 && !removing) return;   // a write waits; settle() re-evaluates
      // A removal is never held behind a write: it goes out now, with keepalive, so an unload cannot drop it.
      const alone = outstanding === 0;
      if (!alone) dirty = true;
      outstanding += 1;
      if (!removing) pendingWrites += 1;
      post(attributes, alone).then(() => settle(!removing));
    };
    // 2. Containment: nothing in the identifier sync may throw into the code that follows this block.
    const runSync = () => { try { syncGaCartNow(); } catch (_) { /* analytics must never interrupt shopping */ } };
    const syncGaCart = () => { autoLeft = MAX_AUTO; runSync(); };
    // A confirmed Dawn cart update invalidates the initial server-rendered count.
    // Read the cart rather than assuming add responses contain the whole cart.
    // A stale/overlapping read may update count only; never clear pending-write/dirty state.
    let cartReadVersion = 0;
    const refreshGaCart = () => {
      const version = ++cartReadVersion;
      const root = window.Shopify?.routes?.root || '/';
      fetch(`${root}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then((r) => { if (!r.ok) throw new Error('cart unavailable'); return r.json(); })
        .then((cart) => {
          if (version !== cartReadVersion || !state || !Number.isInteger(cart.item_count) || cart.item_count < 0) return;
          state.count = cart.item_count;
          syncGaCart(); // current consent is checked again after the asynchronous cart read
        }).catch(() => { try { document.documentElement.dataset.jGaSync = 'cart-read-failed'; } catch (_) {} });
    };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshGaCart);
    }
    loadConsent(syncGaCart);
    document.addEventListener('visitorConsentCollected', () => { consentApi = window.Shopify?.customerPrivacy || consentApi; consentSettled = true; syncGaCart(); });
    setTimeout(() => {
      try {
        const now = readCookies();
        if (!firstSeen || firstSeen.cid === null || now.cid !== firstSeen.cid || now.sid !== firstSeen.sid) syncGaCart();
        // One more bounded look if gtag has still not written _ga at +3 s (C6).
        if (now.cid === null) setTimeout(syncGaCart, 7000);
      } catch (_) { /* analytics must never interrupt shopping */ }
    }, 3000);
  }

  // The sticky control delegates to the real product form and mirrors its pending/sold-out state.
  const productForm = document.querySelector('product-form[data-j-section]');
  if (productForm) {
    const original = productForm.querySelector('[name="add"]');
    const price = document.getElementById(`price-${productForm.dataset.jSection}`);
    const getPicker = () => document.getElementById(`variant-selects-${productForm.dataset.jSection}`);
    const bar = document.createElement('div'); bar.className = 'j-sticky-buy'; bar.hidden = true;
    const priceLabel = document.createElement('span');
    const button = document.createElement('button'); button.type = 'button'; button.className = 'j-btn';
    bar.append(priceLabel, button); document.body.append(bar);
    const sync = () => {
      const picker = getPicker();
      const missing = picker?.querySelector('[data-j-option="size"]') && !picker.querySelector('[data-j-option="size"] :checked');
      button.textContent = missing ? 'Choose your size' : original.querySelector('span')?.textContent.trim() || 'Add to cart';
      button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
      const actual = price?.querySelector('.price-item--regular');
      priceLabel.textContent = actual?.textContent.trim() || '';
      const box = original.getBoundingClientRect();
      const obstructed = document.querySelector('modal-dialog[open], product-modal[open], cart-drawer.active, .shopify-pc__banner__dialog, .shopify-pc__prefs__dialog, .j-mobile-nav:not([hidden])');
      bar.hidden = window.innerWidth > 749 || obstructed || (box.top >= 0 && box.bottom <= window.innerHeight);
    };
    button.addEventListener('click', () => {
      const picker = getPicker();
      const group = picker?.querySelector('[data-j-option="size"]');
      if (group && !group.querySelector(':checked')) {
        group.scrollIntoView({ block: 'center', behavior: 'smooth' });
        group.querySelector('input')?.focus({ preventScroll: true });
      } else original.click();
    });
    let pending = false;
    const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(() => { pending = false; sync(); }); } };
    new MutationObserver(schedule).observe(productForm, { subtree: true, attributes: true, childList: true, characterData: true });
    if (price) new MutationObserver(schedule).observe(price, { subtree: true, childList: true, characterData: true });
    window.addEventListener('scroll', schedule, { passive: true }); window.addEventListener('resize', schedule);
    document.addEventListener('click', schedule); document.addEventListener('change', schedule); sync();
  }

  let cartVersion = 0;
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      cartVersion += 1;
      document.querySelectorAll('[data-j-shipping-result]').forEach((n) => { n.textContent = 'Your cart changed. Estimate shipping again.'; });
    });
  }
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-j-shipping-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button'); if (button.disabled) return;
    const output = form.querySelector('[data-j-shipping-result]');
    const version = cartVersion; const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    button.disabled = true; output.textContent = 'Calculating shipping…';
    const params = new URLSearchParams({ 'shipping_address[country]': 'United States', 'shipping_address[province]': form.elements.province.value, 'shipping_address[zip]': form.elements.zip.value });
    const root = window.Shopify?.routes?.root || '/';
    const request = async (path, method = 'GET') => {
      const response = await fetch(`${root}cart/${path}?${params}`, { method, signal: controller.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('rate_unavailable');
      return response.json();
    };
    try {
      await request('prepare_shipping_rates.json', 'POST');
      let rates = null;
      for (let attempt = 0; attempt < 10 && !rates; attempt += 1) {
        if (attempt) await new Promise((resolve) => setTimeout(resolve, 1200));
        rates = await request('async_shipping_rates.json');
      }
      if (cartVersion !== version || !form.isConnected) return;
      if (!rates) throw new Error('rate_timeout');
      output.replaceChildren();
      const items = rates.shipping_rates || [];
      if (!items.length) output.textContent = 'No estimate is available for this destination. Check the address at checkout or contact the shop.';
      items.forEach((rate) => {
        const line = document.createElement('p');
        const currency = rate.currency || form.closest('[data-j-currency]').dataset.jCurrency || 'USD';
        line.textContent = `${rate.presentment_name || rate.name}: ${new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(Number(rate.price))}`;
        output.append(line);
      });
    } catch (_) {
      if (cartVersion === version && form.isConnected) output.textContent = 'We couldn’t calculate shipping. Check your state and ZIP, or continue to checkout for the final options.';
    } finally { clearTimeout(timeout); button.disabled = false; }
  });
})();

(() => {
 const topic = document.querySelector('[data-j-contact-topic]');
 if (!topic) return;
 const params = new URLSearchParams(location.search);
 const allowed = Array.from(topic.options).map(o => o.value);
 if (allowed.includes(params.get('topic'))) topic.value = params.get('topic');
 const product = document.getElementById('ContactForm-product');
 if (product && /^[a-z0-9-]{1,150}$/.test(params.get('product') || '')) product.value = params.get('product');
 const update = () => {
  const fit = document.querySelector('[data-j-fit-help]');
  const review = document.querySelector('[data-j-review-help]');
  const body = document.getElementById('ContactForm-body');
  if (fit) fit.hidden = topic.value !== 'fit';
  if (review) review.hidden = topic.value !== 'review';
  const activeHelp = topic.value === 'fit' ? fit : topic.value === 'review' ? review : null;
  if (body && activeHelp) body.setAttribute('aria-describedby', activeHelp.id);
  else if (body) body.removeAttribute('aria-describedby');
 };
 topic.addEventListener('change', update); update();
})();
